// CSS
import 'antd/dist/antd.css';
import 'react-awesome-slider/dist/styles.css';
import 'react-toastify/dist/ReactToastify.min.css';
import './assets/css/main.min.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// Page
import App from './App';
// Redux
import Store from './store';
// ServiceWorker
import * as sw from './sw';

ReactDOM.render(
  <BrowserRouter>
    <Provider store={Store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);
sw.register();
React.createElement();
